import { render } from "./ManageVolumes.vue?vue&type=template&id=45feafeb&scoped=true"
import script from "./ManageVolumes.vue?vue&type=script&lang=js"
export * from "./ManageVolumes.vue?vue&type=script&lang=js"

import "./ManageVolumes.vue?vue&type=style&index=0&id=45feafeb&scoped=true&lang=less"

import exportComponent from "/home/biktorgj/Projects/Linube Cloud/Server_and_UI/ui-prod-4.22/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45feafeb"]])

export default __exports__